import { Component, EventEmitter, Output, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { faCamera, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-review-modal',
  templateUrl: './review-modal.component.html',
  styleUrls: ['./review-modal.component.scss']
})
export class ReviewModalComponent {
  @ViewChild('content') content!: TemplateRef<any>;
  @Output() closed = new EventEmitter<void>();

  faStarRegular = faStarRegular;
  faStarSolid = faStarSolid;
  faCamera = faCamera;
  faTimes = faTimes;
  
  ratingProduct = 0;
  comment = '';
  selectedImage: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;
  
  @Input() productoId: number;
  @Input() ordeId: number;
  @Output() reviewSubmitted = new EventEmitter<any>();

  constructor(private modalService: NgbModal) {
    this.ratingProduct = 0;
    this.comment = '';
  }

  open() {
    if (this.content) {
      this.modalService.open(this.content, { centered: true, backdrop: 'static', windowClass: 'review-modal' });
    } else {
      console.error("No se encontró la referencia al template del modal.");
    }
  }

  shouldDisableButton(): boolean {
    return this.ratingProduct === 0;
  }

  close() {
    this.modalService.dismissAll();
    this.ratingProduct = 0;
    this.comment = '';
    this.selectedImage = null;
    this.selectedFile = null;
    this.closed.emit();
  }

  calificate() {
    const respuesta = {
      orderId: this.ordeId,
      productId: this.productoId,
      rating: this.ratingProduct,
      comment: this.comment,
      image: this.selectedFile
    };
    this.reviewSubmitted.emit(respuesta);
    this.modalService.dismissAll();
    this.ratingProduct = 0;
    this.comment = '';
    this.selectedImage = null;
    this.selectedFile = null;
  }

  setRatingProduct(value: number) {
    this.ratingProduct = value;
  }

  cleanEmojis(event: any) {
    const texto = event.target.value;
    const textoLimpio = texto.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/ug, '');

    if (texto !== textoLimpio) {
      this.comment = textoLimpio;
      event.target.value = textoLimpio;
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImage = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.selectedImage = null;
    this.selectedFile = null;
  }
}